import Prism from 'prismjs';

Prism.languages.pseudocode = {
  'keyword': /\b(Algorithm|begin|repeat|fim|U|error|at end of simulation time)\b/,
  'number': /\b\d+\b/,
  'operator': /[←−∗]/,
  'punctuation': /[();]/,
};
